"use strict";
exports.__esModule = true;
exports.getEventMetadata = void 0;
var typeUtils_1 = require("../util/typeUtils");
function getEventMetadata(eventName, clientTs) {
    return {
        event_name: eventName,
        client_ts: (0, typeUtils_1.asTimestamp)(clientTs),
        device_connectivity: getConnectivityType(),
        connection_download_bandwidth_bps: getBandwidthBps()
    };
}
exports.getEventMetadata = getEventMetadata;
function getConnectivityType() {
    var _a, _b;
    switch ((_b = (_a = self.navigator) === null || _a === void 0 ? void 0 : _a.connection) === null || _b === void 0 ? void 0 : _b.type) {
        case "bluetooth":
            return "BLUETOOTH";
        case "cellular":
            return "MOBILE";
        case "wifi":
            return "WIFI";
        case "ethernet":
            return "ETHERNET";
        case "none":
            return "UNREACHABLE";
        default:
            return undefined;
    }
}
function getBandwidthBps() {
    var _a, _b;
    if (!((_b = (_a = self.navigator) === null || _a === void 0 ? void 0 : _a.connection) === null || _b === void 0 ? void 0 : _b.downlink)) {
        return undefined;
    }
    return self.navigator.connection.downlink * 1024 * 1024;
}
//# sourceMappingURL=eventMetadata.js.map